import React, { Component } from 'react'
// import { connect } from 'react-redux'
import { reduxForm, Field } from 'redux-form'
// import * as actions from '../../actions'
// import * as actionCreators from '../../actions';
import { renderTextField, renderCheckbox, renderSelectField } from '../auth/form_helpers'

import '../../style/style.css';

import RaisedButton from 'material-ui/RaisedButton'
// import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
// import Popover from 'material-ui/Popover';
// import Checkbox from 'material-ui/Checkbox';
// import Divider from 'material-ui/Divider';
// import TextField from 'material-ui/TextField'
// import DatePicker from 'material-ui/DatePicker';
import Paper from 'material-ui/Paper';
// import TextField from 'material-ui/TextField';

// import * as actionCreator from '../../actions'
import IconButton from 'material-ui/IconButton';
import ContentClear from 'material-ui/svg-icons/content/clear';

const styles = {
  block: {
    maxWidth: 250,
  },
  checkbox: {
    marginBottom: 16,
  },
  thin: {
    paddingTop: 0,
    paddingBottom: 0,
    marginBottom: 0,
    background: '#E1F5FE',
  },
  halfthin: {
    paddingBottom: 0,
    marginBottom: 0,
    background: '#E1F5FE',
  },
  tobottom: {
    bottom: 0,
    top: "auto"
  }
};

var years = [];
var d = new Date();
var n = d.getFullYear();
for (var i = ( n + 2 ); i >= 1989; i--) { 
   years.push({name: i, year: i});
}

class SkgroupsListFilter extends Component {

  renderAlert() {
    if (this.props.errorMessage) {
      return <div className="alert alert-danger">
        <strong>Oops: </strong>{this.props.errorMessage}
      </div>
    }
  }

  delete (text) {
    return () => {
        this.props.change(text, null)
      //this.props.onSubmit(this.refs.user.getValue(), this.refs.password.getValue())
    }
  }

  renderYears() {
    // if (typeof this.props.groupsbyyear !== 'undefined') {
      return <Field
          component={renderSelectField}
          floatingLabelText={"Év"}
          name={"year"}
        >
          <MenuItem key={101} value='all' primaryText='összes' />
          {
            years.sort(function(a, b){return b.year-a.year}).map((option, index) => {
              return <MenuItem key={index} value={option.year} primaryText={option.year} />
            })
          }
        </Field>
    // }
  }

  render() {
    // console.log(this)
    const {handleSubmit} = this.props
    return (
      <div>
        {this.renderAlert()}
        <Paper zDepth={1} style={{/*position: "fixed", bottom:"0",*/ width:"100%", background: "#E1F5FE", zIndex: "10"}}>
          <form onSubmit={handleSubmit} className='flexContainer'>
            <Paper zDepth={0} style={styles.thin}>
              <Field
                component={renderTextField}
                floatingLabelText="vezető, pozíciószám"
                name="query"
                type="text"/>
            </Paper>
            <Paper zDepth={0} style={styles.thin}>
              {this.renderYears()}
              {/*}
              <Field
                className={
                  typeof this.props.tracker !== 'undefined' ?
                    typeof this.props.tracker.values !== 'undefined' ?
                      typeof this.props.tracker.values.start !== 'undefined' ?
                        this.props.tracker.values.start === null ? 'deleted'
                        : 'ac1'
                      : 'ac2'
                    : 'ac3'
                  : 'ac4'
                }
                component={renderDatePicker}
                floatingLabelText="kezdés"
                label="kezdés"
                name="start" />
                {
                  typeof this.props.tracker !== 'undefined' ?
                    typeof this.props.tracker.values !== 'undefined' ?
                      typeof this.props.tracker.values.start !== 'undefined' ?
                        this.props.tracker.values.start !== null ? (<div className="">
                            <IconButton onClick={this.delete("start")} className="deleteIcon">
                              <ContentClear />
                            </IconButton>
                          </div>)
                        : void(0)
                      : void(0)
                    : void(0)
                  : void(0)
                }
              */}
            </Paper>
            <Paper zDepth={0} style={styles.halfthin}>
              <RaisedButton type="submit" label="szűrés" primary={true} labelColor={'#FFFFFF'}/>
            </Paper>
          </form>
        </Paper>
      </div>
    )
  }

}

// PersonListFilter = reduxForm({
//   form: 'personListFilter'
// })(PersonListFilter)

// You have to connect() to any reducers that you wish to connect to yourself
//PersonListFilter = connect(
  //state => ({
  //  initialValues: state.person.thisperson // pull initial values from reducer
  //})//,
  //{ load: loadAccount }               // bind account loading action creator
//)(PersonListFilter)

export default reduxForm({
  form: 'skgroupsListFilter',
  initialValues: {category: 'all'}
})(SkgroupsListFilter)


// WEBPACK FOOTER //
// ./src/components/selfknowledgegroups/skgroupsListFilter.js